import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function CloseEmailEnvelopeIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      height={height || 80}
      width={width || 110}
      viewBox="153.129 175.766 104.527 87.883"
    >
      <path
        d="M260.46 145.79a8.813 8.813 0 00-8.8-8.8h-70.4c-4.85.01-8.78 3.94-8.8 8.8v52.8a8.839 8.839 0 008.8 8.8h70.4c4.86-.02 8.79-3.95 8.8-8.8v-52.8zm-8.8 0l-35.2 22-35.2-22h70.4zm0 52.8h-70.4v-44l35.2 22 35.2-22v44z"
        fill={color || "#fb972e"}
        transform="translate(-11.651 46.966)"
      />
      <path
        d="M260.46 145.79a8.813 8.813 0 00-8.8-8.8h-70.4c-4.85.01-8.78 3.94-8.8 8.8v52.8a8.839 8.839 0 008.8 8.8h70.4c4.86-.02 8.79-3.95 8.8-8.8v-52.8zm-8.8 0l-35.2 22-35.2-22h70.4zm0 52.8h-70.4v-44l35.2 22 35.2-22v44z"
        fill="none"
        transform="translate(-11.651 46.966)"
      />
      <path
        d="M252.62 185.15c-8.28 0-15 6.71-15 15 0 8.28 6.72 15 15 15 8.29 0 15-6.72 15-15 0-8.29-6.71-15-15-15z"
        fill="#2f2f2f"
        transform="translate(-11.651 46.966)"
      />
      <path
        d="M252.62 185.15c-8.28 0-15 6.71-15 15 0 8.28 6.72 15 15 15 8.29 0 15-6.72 15-15 0-8.29-6.71-15-15-15z"
        fill="none"
        transform="translate(-11.651 46.966)"
      />
      <g>
        <path
          d="M254.9 200.15c2.04-2.05 3.18-3.19 3.41-3.41.42-.42.42-1.1 0-1.52-.08-.07-.68-.68-.76-.76-.42-.42-1.1-.42-1.52 0-.22.23-1.36 1.37-3.41 3.41l-3.41-3.41c-.42-.42-1.1-.42-1.51 0l-.76.76c-.42.42-.42 1.1 0 1.52.23.22 1.36 1.36 3.41 3.41l-3.41 3.41c-.42.42-.42 1.1 0 1.52.07.07.68.68.76.75.41.42 1.09.42 1.51 0 .23-.22 1.37-1.36 3.41-3.41 2.05 2.05 3.19 3.19 3.42 3.41.41.42 1.09.42 1.51 0 .08-.07.68-.68.76-.75.42-.42.42-1.1 0-1.52l-3.41-3.41z"
          fill="#fff"
          transform="translate(-11.651 46.966)"
        />
        <path
          d="M254.9 200.15c2.04-2.05 3.18-3.19 3.41-3.41.42-.42.42-1.1 0-1.52-.08-.07-.68-.68-.76-.76-.42-.42-1.1-.42-1.52 0-.22.23-1.36 1.37-3.41 3.41l-3.41-3.41c-.42-.42-1.1-.42-1.51 0l-.76.76c-.42.42-.42 1.1 0 1.52.23.22 1.36 1.36 3.41 3.41l-3.41 3.41c-.42.42-.42 1.1 0 1.52.07.07.68.68.76.75.41.42 1.09.42 1.51 0 .23-.22 1.37-1.36 3.41-3.41 2.05 2.05 3.19 3.19 3.42 3.41.41.42 1.09.42 1.51 0 .08-.07.68-.68.76-.75.42-.42.42-1.1 0-1.52l-3.41-3.41z"
          fill="none"
          transform="translate(-11.651 46.966)"
        />
      </g>
    </svg>
  );
}
